<template>
    <div class="modal-content">

      <div class="modal-header">
        <span class="modal-icon">📱</span>
        <h2 class="modal-title">Install Chessvis AI</h2>
        <p class="modal-sub">Add to your home screen for quick access</p>
      </div>

      <div class="steps">
        <div class="step">
          <span class="step-num">1</span>
          <div class="step-text">
            Tap the <strong>Share button</strong>
            <span class="share-icon"> ⎋ </span>
            at the bottom of your screen
          </div>
        </div>
        <div class="step">
          <span class="step-num">2</span>
          <div class="step-text">
            Scroll down and tap <strong>"Add to Home Screen"</strong>
          </div>
        </div>
        <div class="step">
          <span class="step-num">3</span>
          <div class="step-text">
            Tap <strong>"Add"</strong> in the top right corner
          </div>
        </div>
      </div>

      <!-- <div class="dont-show-row">
        <ion-checkbox
          v-model="dontShowAgain"
          class="dont-show-checkbox"
        />
        <span class="dont-show-label">Don't show this again</span>
      </div> -->

      <ion-button
        expand="block"
        class="got-it-btn"
        @click="dismiss"
      >
        Got it
      </ion-button>

    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { IonModal, IonButton, IonCheckbox, modalController } from '@ionic/vue'

// ── State ──────────────────────────────────────────────────────────────────
const dontShowAgain  = ref(false)
const isDismissed    = ref(false)

// ── Computed ───────────────────────────────────────────────────────────────

// ── Actions ────────────────────────────────────────────────────────────────

function dismiss() {
  if (dontShowAgain.value) {
    localStorage.setItem('iosInstallDismissed', 'true')
    isDismissed.value = true
  }
  modalController.dismiss(null, 'cancel');
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Crimson+Pro:ital,wght@0,400;0,600;1,400&display=swap'); */

/* ── Modal ─────────────────────────────────────────────────────────────── */
.ios-install-modal {
  --background: transparent;
  --backdrop-opacity: 0.5;
}

.modal-content {
  background: #1a1208;
  border-radius: 16px 16px 0 0;
  border-top: 1px solid rgba(200,169,122,0.2);
  padding: 28px 24px;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
  font-family: Arial, Helvetica, sans-serif;
}

/* ── Header ────────────────────────────────────────────────────────────── */
.modal-header {
  text-align: center;
  margin-bottom: 28px;
}
.modal-icon {
  font-size: 36px;
  display: block;
  margin-bottom: 10px;
}
.modal-title {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 6px;
}
.modal-sub {
  font-size: 14px;
  color: rgba(255,255,255,0.4);
  font-style: italic;
}

/* ── Steps ─────────────────────────────────────────────────────────────── */
.steps {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}
.step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.step-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(200,169,122,0.15);
  border: 1px solid rgba(200,169,122,0.3);
  color: #c8a97a;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.step-text {
  font-size: 15px;
  color: rgba(255,255,255,1.0);
  line-height: 1.5;
}
.step-text strong {
  color: #fff;
  font-weight: 600;
}
.share-icon {
  font-size: 16px;
  color: #c8a97a;
}

/* ── Don't show again ──────────────────────────────────────────────────── */
.dont-show-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding: 12px 0;
  border-top: 1px solid rgba(255,255,255,0.07);
}
.dont-show-checkbox {
  --background: transparent;
  --background-checked: rgba(200,169,122,0.3);
  --border-color: rgba(255,255,255,0.2);
  --border-color-checked: #c8a97a;
  --checkmark-color: #c8a97a;
}
.dont-show-label {
  font-size: 14px;
  color: rgba(255,255,255,1.0);
}

/* ── Got it button ─────────────────────────────────────────────────────── */
.got-it-btn {
  --background: #fff;
  --background-activated: #ede2ce;
  --color: #1a1208;
  --border-radius: 8px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0;
  height: 50px;
}
</style>
